module.exports = __webpack_public_path__ + "static/media/Mother calling cubs [REDUCED].ad1bc2bc.m4v";